import { Box, Button, Grid, Paper, Typography, useMediaQuery } from '@mui/material'
import {amber, green, headingBlue, maroon} from '../../assets/colors'
import { useEffect, useState } from 'react'
import CustomTextField from '../CustomTextField';
import CustomDropDown from '../CustomDropDown';
import {buttonStyle, containerStyle, errorTextStyle, imgContainer, imgStyle} from '../../utils/commonCSS'
import WORKslogans from '../WORKslogans';
import { validateContact, validateDistrict, validateGender, validateState } from '../../utils/validations';
import { generateQuizCertificate, getAllDistrictsForState, getAllStates, getNRQuizContactPerson, updateParticipantDetails } from '../../backend/backendApis';
import HttpService from '../../backend/requestApis';
import { genderList } from '../../utils/constants';
import Loader from '../Loader';
import DownloadIcon from '@mui/icons-material/Download';


const QuizPage = () => {

  const isMobile = useMediaQuery("(max-width:1000px)");
  const [contactNumber, setContactNumber] = useState('')
  const [contactError, setContactError] = useState('')
  const [showRegistrationForm, setShowRegistrationForm] = useState(null)
  const [contPersonDetails, setContPersonDetails] = useState([])
  const [participantDetails, setParticipantDetails] = useState([])
  const [stateList, setStateList] = useState([])
  const [selectedState, setSelectedState] = useState('Select State')
  const [stateError, setStateError] = useState('')
  const [selectGender, setSelectedGender] = useState('Select Gender')
  const [genderError, setGenderError] = useState('')
  const [districtList, setDistrictList] = useState([])
  const [selectedDistrict, setSelectedDistrict] = useState('Select District')
  const [districtError, setDistrictError] = useState('')
  const [isRegistered, setIsregistered] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [apiErr, setApiErr] = useState('')

  const updateContactNumber = (value) => {
    setContactNumber(value)
  }

  const handleSubmit = () => {
    setIsLoading(true)
    let isValid = true

    setApiErr('')

    let contactValidations = validateContact(contactNumber)

    if( contactValidations != ''){
      isValid = false
      setContactError('Invalid Contact Number')
    } else {
      setContactError('')
    }

    if( isValid) {
      let options = {
        url: getNRQuizContactPerson,
        method: 'GET',
        params: {
          contactNumber: contactNumber
        },
        headers: {
          authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }
      HttpService(options).then(resp => {
        let respData = resp?.data?.data
        if( respData?.isRegistered){
          setIsregistered(true)
          setContPersonDetails(respData?.contactPersonDetails)
          setParticipantDetails(respData?.partcipantDetails)
          setIsLoading(false)
        } else {
          setIsregistered(false)
          setContPersonDetails([])
          setShowRegistrationForm(true)
          setIsLoading(false)
        }
      }).catch(err => {
        console.log("Error in fetching contact person details: ", err)
        setApiErr(err?.response?.data?.message)
        setIsLoading(false)
      })
    } else {
      setIsLoading(false)
    }
  }

  const handleSelectedGender = (value) => {
    setSelectedGender(value)
  }

  const handleSelectedState = (value) => {
    setSelectedState(value)
  }

  const handleSelectedDistrict = (value) => {
    setSelectedDistrict(value)
  }

  const handleUpdate = () => {
    setIsLoading(true)
    let isValid = true

    let genderValidation = validateGender(selectGender)

    if( genderValidation != ''){
      setGenderError(genderValidation)
      isValid = false
    } else {
      setGenderError('')
    }

    let stateValidation = validateState(selectedState)

    if( stateValidation != ''){
      setStateError(stateValidation)
      isValid = false
    } else {
      setStateError('')
    }

    let districtValidation = validateDistrict(selectedDistrict)

    if( districtValidation != ''){
      setDistrictError(districtValidation)
      isValid= false
    } else {
      setDistrictError('')
    }

    if( isValid){
      let options = {
        url: updateParticipantDetails,
        method: 'POST',
        payload: {
          contactNumber: contactNumber,
          gender: selectGender,
          district: selectedDistrict,
          state: selectedState
        },
        headers: {
          headers: {
            authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
      }

      HttpService(options).then(resp => {
        setShowRegistrationForm(false)
        handleSubmit()
      }).catch(err => {
        setApiErr(err?.response?.data?.message)
      })
    } else {
      setIsLoading(false)
    }

  }

  const downloadCertificate = async () => {

    setIsLoading(true)

    let options = {
      url: generateQuizCertificate,
      method: 'GET',
      params: {
        name: participantDetails['name']
      },
      responseType: 'arraybuffer'
    }
    HttpService(options).then (async resp => {
      const blob = new Blob([resp.data], {type: 'image/png'})
      const url = window.URL.createObjectURL(blob)
       const link = document.createElement('a')
       link.href = url
       link.download = 'certificate.png'
       link.click()
       window.URL.revokeObjectURL(url);
       setIsLoading(false)
    }).catch(err => {
      console.log("Error in generating quiz certificate: ", err)
      setApiErr('Error in Generating Certificate. Please Contact Support.')
      setIsLoading(false)
    })

  }

  useEffect(() => {
    if(showRegistrationForm === true){
      setIsLoading(true)
      let options = {
        url: getAllStates,
        method: 'GET',
        params:{
          isStateNameReq: true
        },
        headers: {
          authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      }
      HttpService(options).then(resp => {
        setStateList(resp?.data?.data)
        setIsLoading(false)
      }).catch(err => {
        setApiErr(err?.response?.data?.message)
        setIsLoading(false)
      })
    }
  }, [showRegistrationForm])

  useEffect(() => {
    setIsLoading(true)
    let options = {
      url: getAllDistrictsForState,
      method: 'GET',
      params: {
        state: selectedState,
        isStateNameReq: true
      },
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer localStorage.getItem('token')` : null
      }
    }
    HttpService(options).then(resp => {
      setDistrictList(resp?.data?.data)
      setIsLoading(false)
    }).catch(err => {
      setApiErr(err?.response?.data?.message)
      setIsLoading(false)
    })
  }, [selectedState])

  useEffect(() => {
    setApiErr('')
    setContactError('')
    setGenderError('')
    setStateError('')
    setDistrictError('')
  }, [])

  return (
    <>
        <Box style={{backgroundColor: headingBlue, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Typography style={{fontSize: isMobile ? '1.5rem' : '2.5rem'}}>
              NABI E REHMAT QUIZ
          </Typography>
        </Box>
        <div style={{...containerStyle, maxWidth: isMobile ? '20rem' : '30rem'}}>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WORKslogans />
          </div> */}
          <div style={{...imgContainer}}>
            <img
              src={require("../../assets/images/compassionMonth.png")}
              style={imgStyle}
            ></img>
          </div>

          <Paper style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <Box style={{width: '98%', padding: '0.6rem 0.5rem 0.5rem 0.7rem', color: headingBlue}}>
              {/* <Typography style={{fontSize: '1.1rem', fontWeight: 600}}>Get Contact Person Details</Typography> */}
            </Box>
            {isLoading && <Loader/>}
            <Box style={{width: '98%', marginTop: '0.5rem', padding: '0.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
              {(!isRegistered && !showRegistrationForm) &&
              <CustomTextField 
                placeHolder = 'Enter Contact Number'
                value={contactNumber}
                setFunc={updateContactNumber}
                width={isMobile ? '13rem' : null}
              ></CustomTextField>}
              <Typography style={{...errorTextStyle}}>{contactError}</Typography>
              {showRegistrationForm && 
                <Grid container spacing= {1} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0.5rem'}}>
                  <Grid item xs={7} sm={7} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center'}}>
                    <CustomDropDown 
                      list={genderList} 
                      value={selectGender} 
                      setFunc={handleSelectedGender}
                      placeHolder='Select Gender' 
                      regular={true} width='13rem'></CustomDropDown>
                      <Typography style={{...errorTextStyle}}>{genderError}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center'}}>
                    <CustomDropDown 
                      list={stateList} 
                      value={selectedState} 
                      setFunc={handleSelectedState}
                      placeHolder='Select State' 
                      regular={true} width='13rem'></CustomDropDown>
                      <Typography style={{...errorTextStyle}} >{stateError}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center'}}>
                    <CustomDropDown 
                      list={districtList}
                      value={selectedDistrict}
                      setFunc={handleSelectedDistrict}
                      placeHolder='Select District' 
                      regular={true} width='13rem'></CustomDropDown>
                      <Typography style={{...errorTextStyle}}>{districtError}</Typography>
                  </Grid>

                </Grid>    
              }
          
          { isRegistered ? 
            <>
            <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '80%', padding: '0.5rem 0.5rem 0rem 0.5rem'}}>
              {isMobile ?<Typography style={{color: green, fontSize: '1rem', fontWeight: 600, textAlign: 'center'}}>Assalamalaikum <br></br> {participantDetails['name']}</Typography>:
              <Typography style={{color: green, fontSize: '1rem', fontWeight: 600, textAlign: 'center'}}>Assalamalaikum {participantDetails['name']}</Typography>}
              <Box 
              // style={{padding: '0.1rem 0.5rem 0.5rem 0.5rem', display: 'grid', gridTemplateColumns: "2fr 2fr", gap: '1rem', color: maroon, alignItems: 'center'}}
              >
                <Typography style={{fontSize: '1.2rem', textAlign: 'center', color: headingBlue, marginTop: '1rem'}}> {participantDetails?.Marks2025 ? `Score: ${participantDetails?.Marks2025}` : ''}</Typography>
                {/* <Button style={{...buttonStyle}}>Certificate</Button> */}
                { (participantDetails?.Marks2025 && participantDetails?.Marks2025 >= 35) ?
                <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
                  onClick={() => downloadCertificate(participantDetails['name'])}
                >
                  <DownloadIcon style={{color: headingBlue}}></DownloadIcon>
                  <Typography style={{color: headingBlue, fontSize: '0.95rem'}}> Download Certificate</Typography>
                </Box> : <></>}
                

              </Box>
            </Box>
            <Box style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', width: '80%', marginTop: '1rem', padding: '0.5rem 0.5rem 0rem 0.5rem'}}>
              <Typography style={{color: amber, fontSize: isMobile ? '0.9rem': '1rem', fontWeight: 600}}>Contact Person Details</Typography>
              <Box style={{padding: '0.1rem 0.5rem 0.5rem 0.5rem', display: 'grid', gridTemplateColumns: "2fr 2fr", gap: '1rem', color: maroon, alignItems: 'center'}}>
                  <Typography style={{fontSize: isMobile ? '0.9rem': '1rem', textAlign: 'center'}}> {
                  contPersonDetails['nrQuizContactMale'] ? 
                  contPersonDetails['nrQuizContactMale'] : 
                  contPersonDetails['nrQuizContactFemale'] ? 
                  contPersonDetails['nrQuizContactFemale'] : 
                  'Not Available'}</Typography>
                  <Typography style={{fontSize: isMobile ? '0.9rem': '1rem', textAlign: 'center', alignItems: 'center'}}> {
                  contPersonDetails['nrQuizContactMaleCN'] ? 
                  contPersonDetails['nrQuizContactMaleCN'] : 
                  contPersonDetails['nrQuizContactFemaleCN'] ? 
                  contPersonDetails['nrQuizContactFemaleCN'] : 
                  'Not Available'}</Typography> 
              </Box>
            </Box>
            
              
              </>
            
            :
          
          showRegistrationForm ?
            <Box style={{padding: '0.8rem'}}>
              <Button style={{...buttonStyle}}
                onClick={() => handleUpdate()}
              >Update</Button>
            </Box>:
            <Box style={{padding: '0.8rem', }}>
              <Button style={{...buttonStyle}}
                onClick={() => handleSubmit()}
              >Submit</Button>
            </Box>}

          <Box>
            <Typography style={{...errorTextStyle}}>{apiErr}</Typography>
          </Box>  
            </Box>

          </Paper>

          {/* <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5rem', marginTop: '1rem'}}>
            <Button style={{...buttonStyle, fontSize: '1.5rem', backgroundColor: amber, padding: '0.5rem 1rem 0.5rem 1rem', borderRadius: '0.5rem'}}>Certificate</Button>
          </Box> */}

          <Box style={{ padding: '1rem 0.3rem 0rem 0.3rem',display: 'flex', justifyContent: 'center'}}>
            <Box style={{padding: '0.2rem'}}>
              <img 
                    src={require('../../assets/images/androidQR.png')}
                    style={{width: isMobile ? '100px' : '200px', height: isMobile ? '100px' : '200px'}}></img>
                  <Typography style={{textAlign: 'center'}}> Android</Typography>
            </Box>
            <Box style={{padding: '0.2rem 0.3rem 0.2rem 0.3rem'}}>
              <img 
                    src={require('../../assets/images/iphoneQR.png')}
                    style={{width: isMobile ? '100px' : '200px', height: isMobile ? '100px' : '200px'}}></img>
                  <Typography style={{textAlign: 'center'}}> Iphone</Typography>
            </Box>

          </Box>
          <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Typography>Org Code: EINWZ</Typography>
          </Box>
          </div>

    </>
  )
}

export default QuizPage
